import React from 'react';
import Row from '../UI/Containers/Row';
import { Menu, User2Icon } from 'lucide-react';
import Column from '../UI/Containers/Column';
import { HeaderText, SubtitleText } from '../UI/Typography/PageHeader';
import { useUserRoleType } from '../../pages/Account/hooks/useUserRoleType';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../LanguageToggleButton';
import { Divider } from '@material-ui/core';
import { useLocale } from '../../hooks/useLocale';
import { cn } from '../../utils';

const HeaderBarCard = ({ onAvatarClick }: { onAvatarClick?: () => void }) => {
  const { user, currentRole } = useUserRoleType();
  const { t } = useTranslation();

  return (
    //  User card and language toggle
    <Row className="w-full items-center gap-8 justify-end">
      <LanguageToggle />

      {/* User Card */}
      <Row
        onClick={onAvatarClick}
        className="items-center justify-center gap-3 cursor-pointer"
      >
        <Column className="gap-0 items-end">
          <HeaderText className="text-sm" text={user.fullName} />
          <SubtitleText
            className="text-xs"
            text={t(`components.header.${currentRole}`)}
          />
        </Column>
        <div className="w-11 h-11 rounded-full bg-secondary text-white font-semibold text-[9px] sm:text-[11px] centerDiv">
          {`#${user.id}`}
        </div>
      </Row>
    </Row>
  );
};

export default HeaderBarCard;

const TextLangOptions = () => {
  const { isArabic, isEnglish } = useLocale();

  return (
    <Row className="gap-2 items-center">
      <HeaderText
        className={cn(
          'text-sm text-lightGrayText btnEffect',
          isEnglish && 'text-primary'
        )}
        text={'EN'}
      />
      <div className="h-5 w-[1px] bg-borderColor" />
      <HeaderText
        className={cn(
          'text-sm text-lightGrayText btnEffect',
          isArabic && 'text-primary'
        )}
        text={'AR'}
      />
    </Row>
  );
};
